import React from "react";
import { Dropdown } from "antd";

import { FaCaretDown } from "react-icons/fa6";

import images from "../../../assets";

const items = [
  {
    label: (
      <div className="p-5 flex flex-col gap-2">
        <div>My Account</div>
        <div>Settings</div>
        <div className="h-[1px] bg-gray-500"></div>
        <div>Logout</div>
      </div>
    ),
    key: "0",
  },
];

const ProfileDropdownContainer = () => {
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <div className="profile-nav-area">
        <div className="profile-nav-photo">
          <img
            className="profile-circle-photo"
            src={images.defaultMaleIcon}
            alt="img"
          />
        </div>
        <div className="caret-down-icon">
          <FaCaretDown />
        </div>
      </div>
    </Dropdown>
  );
};

export default ProfileDropdownContainer;
